import { Component, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { BorrowerTab } from 'app/store/global-borrower-tabs/borrower-tab';
import { GlobalBorrowerTabClose, GlobalBorrowerTabsCloseAll } from 'app/store/global-borrower-tabs/global-borrower-tabs.actions';
import { GlobalBorrowerTabsState } from 'app/store/global-borrower-tabs/global-borrower-tabs.state';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { CloseTabsDialogComponent } from 'ng2-app/global-borrower-tabs/global-borrower-tabs-smart/close-tabs-dialog.component';

@Component({
  selector: 'app-global-borrower-tabs-smart',
  templateUrl: './global-borrower-tabs-smart.component.html',
  styleUrls: ['./global-borrower-tabs-smart.component.scss'],
  standalone: false
})
export class GlobalBorrowerTabsSmartComponent implements OnDestroy {
  @Select(GlobalBorrowerTabsState.tabs) tabs$: Observable<BorrowerTab[]>;
  @Select(GlobalBorrowerTabsState.activeTab) activeTab$: Observable<BorrowerTab[]>;
  destroyed$ = new Subject<void>();

  constructor(
    private dialog: MatDialog,
    private store: Store
  ) { }

  openConfirmCloseDialog() {
    const dialogRef = this.dialog.open(CloseTabsDialogComponent, {
      width: '300px'
    });

    // wire up confirm
    dialogRef.componentInstance.confirm.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(() => {
      dialogRef.close();
      this.handleCloseAllTabs();
    });
  }

  handleCloseTab(tab: BorrowerTab) {
    this.store.dispatch(new GlobalBorrowerTabClose(tab.tabId));
  }

  handleCloseAllTabs() {
    this.store.dispatch(new GlobalBorrowerTabsCloseAll());
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }
}
